import {createContext, PropsWithChildren, useContext} from 'react'
import type {Country} from 'react-phone-number-input'

/**
 * Country used as the default for phone inputs (the organisation's licence country).
 * Provided once near the app root; an individual phone field can still override it
 * with its own `defaultCountry`, and the user can always pick another country.
 */
const DefaultCountryContext = createContext<Country | undefined>(undefined)

export function DefaultCountryProvider({country, children}: PropsWithChildren<{country?: Country}>) {
  return <DefaultCountryContext.Provider value={country}>{children}</DefaultCountryContext.Provider>
}

export function useDefaultCountry(): Country | undefined {
  return useContext(DefaultCountryContext)
}
